export default __webpack_public_path__ + "static/media/AC.b801a550.svg";